"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCoupleRightImageProperty = exports.coupleRightImagePropertyDefinition = void 0;
exports.coupleRightImagePropertyDefinition = {
    view: {
        label: 'Image',
        style: 'media-preview',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['image'],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'couple-right-image',
};
const isCoupleRightImageProperty = (prop) => {
    return prop.name === exports.coupleRightImagePropertyDefinition.name;
};
exports.isCoupleRightImageProperty = isCoupleRightImageProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY291cGxlLXJpZ2h0LWltYWdlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvY291cGxlLXJpZ2h0LWltYWdlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsa0NBQWtDLEdBQUc7SUFDaEQsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLE9BQU87UUFDZCxLQUFLLEVBQUUsZUFBZTtLQUN2QjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsT0FBTyxDQUFDO1NBQ3BCO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLG9CQUFvQjtDQUNLLENBQUE7QUFJMUIsTUFBTSwwQkFBMEIsR0FBRyxDQUFDLElBQWtCLEVBQW9DLEVBQUU7SUFDakcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDBDQUFrQyxDQUFDLElBQUksQ0FBQTtBQUM5RCxDQUFDLENBQUE7QUFGWSxRQUFBLDBCQUEwQiw4QkFFdEMifQ==